/** @jsxImportSource @emotion/react */
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getProjectAlarmList } from 'apis/admin/Alarm';
import CustomGrid from 'components/grids/CustomGrid';
import CustomDialog from 'components/modals/common/CustomDialog';
import { AlarmSetup } from 'models/admin/Alarm';
import { useTranslation } from 'react-i18next';
import { CellMaker } from '@grapecity/wijmo.grid.cellmaker';

interface AlarmProps {
  open: boolean;
  close: () => void;
}

const AlarmNoticeManagement = ({ open, close }: AlarmProps) => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const [rowData, setRowData] = useState<AlarmSetup[]>([]);
  const navigate = useNavigate();

  const layoutDefinition = [
    {
      binding: 'prjAlmTpNm',
      header: String(t('com.label.업무유형', '업무유형')),
      width: 240,
      isReadOnly: true,
      align: 'left',
      cellTemplate: CellMaker.makeLink({
        text: '<span>${item.prjAlmTpNm}</span>',
        click: (e, ctx) => {
          moveToPage(ctx.item);
        },
      }),
    },
    {
      binding: 'elmPrjNm',
      header: String(t('com.label.프로젝트명', '프로젝트명')),
      width: '*',
      isReadOnly: true,
      align: 'left',
    },
    {
      binding: 'excpNm',
      header: String(t('com.label.협력업체명', '협력업체명')),
      width: 140,
      isReadOnly: true,
      align: 'center',
    },
    {
      binding: 'prjAlmTpMsg',
      header: String(t('com.label.메세지', '메세지')),
      width: 350,
      isReadOnly: true,
      align: 'left',
    },
    {
      binding: 'cnt',
      header: String(t('com.label.건수', '건수')),
      width: 80,
      isReadOnly: true,
      align: 'right',
    },
  ];

  const getAlarmList = async () => {
    getProjectAlarmList().then((result: AlarmSetup[]) => {
      if (result) {
        if (result.length > 0) {
          setRowData(result);
        }
      }
    });
  };

  useEffect(() => {
    if (pathname == '/') {
      getAlarmList();
    }
  }, [pathname]);

  const moveToPage = (item: any) => {
    const url = item?.menuUrl;
    navigate(`${url}`, {
      state: {
        elmPrjId: item?.elmPrjId,
        initialOnly: true,
      },
    });
    close();
  };

  return (
    <CustomDialog
      title={t('com.label.설비셋업 진척 점검', '설비셋업 진척 점검')}
      open={open}
      onClose={close}
    >
      <CustomGrid layoutDefinition={layoutDefinition} rowData={rowData} isSelector={false} />
    </CustomDialog>
  );
};

export default AlarmNoticeManagement;
